module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/main/content/pages/management/schoolyear/add-edit-school-year/add-edit-school-year.component.scss
// module id = ./src/app/main/content/pages/management/schoolyear/add-edit-school-year/add-edit-school-year.component.scss
// module chunks = main